//CSS
import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

const SoftwareData: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="E-SPEC™ Software" />

            <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        <div>
                            <b>Data From our 30-yrs. of R&D​ ​</b>
                            <br />We developed methods to combine data for engine designs dating from the 1880s to this year and compared them and their strengths and weaknesses to each other.
                            Our all-engines databases grew to include information for millions of engines of all types using old and new designs.​<br />
                        </div>
                        <div>
                            <b>E-SPEC (Engines – Size, Power, Efficiency Calculator)​ ​</b>
                            <br />Using optimization algorithms and “Mixed Methods Research,” we developed, our proprietary software, E-SPEC, to predict and compare any engines’ physical and performance data.​​<br />
                        </div>
                        <div>
                            <b>E-SPEC is Unmatched and Will Become “Must-Use”​</b>
                            <br />We add the data that only we have for ELF-Tech engine designs to permit our software users compare engines to each other and/or to proposed new engines and/or to ELF-Tech designs.​<br />
                        </div>
                        <div>
                            <b>E-SPEC Helps Protect IP & Monitor IP Infringement ​​</b>
                            <br />
                            The software and its data gathering apps will process new engines and detect potential infringement on ELF-Tech designs. ​
                            <br />
                        </div>
                        <div>
                            <b>AI Data Gathering Helps Users​​</b>
                            <br />
                            The extensive data (larger due to our AI apps) helps users get the most value as they use our software, and our curated data can teach other AI apps re: engine metrics comparing and ELF-Tech strengths. 
                            <br />
                        </div>
                    </p>{" "}
                </div>
            </SubSection>
        </div>
    );
};

export default SoftwareData;